<custom-modal-card [enableClose]="false" class="inactivity-check-dialog">
  <ng-container body>
    <div class="inactivity-check-dialog__heading">
      <img
        [ngSrc]="'assets/icons/inactivity-illustration.png'"
        height="100"
        width="100"
        alt="Icône de verrouillage"
      />
      <hgroup>
        <h2>Votre session est sur le point d’expirer</h2>
        <p>
          Aucune activité n’a été détectée depuis un moment. Pour des raisons de
          sécurité, vous allez être déconnecté automatiquement.
        </p>
        <p class="inactivity-check-dialog__countdown">
          Déconnexion automatique dans
          <span>{{ countdownLabel() }}</span>
        </p>
      </hgroup>
    </div>
  </ng-container>

  <hr />

  <ng-container footer>
    <div class="inactivity-check-dialog__modal-actions">
      <button
        type="button"
        button
        variant="primaryLight"
        (click)="stayConnected()"
      >
        Rester connecté
      </button>
    </div>
  </ng-container>
</custom-modal-card>
